enum UserSettingKey {
    AllowMarketing = "AllowMarketing"
}

export { UserSettingKey }